import React, {CSSProperties} from "react";

import {EAnalysisTasks, EModules} from "@/models";
import {
    IModuleByTask,
    IModuleGroupDevices,
    IModuleTaskGroup,
} from "@shared/analysis/analyze-button/models";
import {EServerId} from "../../models";

import ModuleIcon, {getTaskInfo} from "@toolbox/display-blocks/ModuleIcon";
import {Link} from "react-router-dom";

const subgridRow: CSSProperties = {
    gridColumn: "1 / -1",
    display: "grid",
    gridTemplateColumns: "subgrid",
    margin: 0,
    padding: 0,
};

export interface IAnalyzeTasksProps {
    project: number;
    serverId: EServerId;
    tasks?: IModuleGroupDevices | undefined;
    columns: number;

    hrefTarget?: string;

    getTargets(engine?: EModules, task?: EAnalysisTasks): string;
    onClick(): void;
}

class AnalyzeTasks extends React.PureComponent<IAnalyzeTasksProps> {
    public render() {
        const {tasks, columns} = this.props;
        if (!tasks) {
            return null;
        }

        const modules = tasks.modules;
        const last = modules.length - 1;

        return modules.map((group, i) => (
            <div key={group.id} className={last !== i ? "mb-2" : undefined}>
                <h5 className="header border-bottom">{group.header}</h5>
                <ul
                    className="list-unstyled"
                    style={{
                        display: "grid",
                        gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
                        gap: "1rem",
                    }}
                >
                    {this.renderButtons(group)}
                </ul>
            </div>
        ));
    }

    private renderButtons(group: IModuleTaskGroup) {
        const {tasks} = this.props;
        if (!tasks) return null;

        return group.modules.map((moduleGroup, i) =>
            this.renderButton(moduleGroup.item),
        );
    }

    private renderButton(
        item: IModuleByTask | IModuleTaskGroup,
        nested = false,
    ) {
        const {onClick, hrefTarget} = this.props;

        // Single task item
        if ("module" in item) {
            const info = getTaskInfo(item.task);
            return (
                <li key={`${item.module}-${item.task}`}>
                    <Link
                        id={`link-to-${item.module}`}
                        target={hrefTarget}
                        to={this.getUrl(item.module, item.task)}
                        onClick={onClick}
                    >
                        <ModuleIcon icon={info.icon} name={info.type} />
                    </Link>
                </li>
            );
        }

        // Nested item group
        const leaves = item.modules.filter((x) => "module" in x.item);
        const groups = item.modules.filter((x) => !("module" in x.item));

        return (
            <li
                key={item.id}
                style={{
                    gridColumn: nested ? "1 / -1" : "2 / -1",
                    display: "grid",
                    gridTemplateColumns: "subgrid",
                }}
            >
                <span className={"mt-2"} style={{gridColumn: "1 / -1"}}>
                    {item.header}
                </span>

                {!!leaves.length && (
                    <ul className="list-unstyled" style={subgridRow}>
                        {leaves.map((x) => this.renderButton(x.item, true))}
                    </ul>
                )}

                {!!groups.length && (
                    <ul className="list-unstyled" style={subgridRow}>
                        {groups.map((x) => this.renderButton(x.item, true))}
                    </ul>
                )}
            </li>
        );
    }

    private getUrl(engine: EModules, task: EAnalysisTasks) {
        const {project, getTargets, serverId} = this.props;
        const targets = getTargets(engine, task);

        return `/project/${project}/${serverId}/analyze?engine=${engine}&${targets}&task=${task}`;
    }
}

export default AnalyzeTasks;
